<button
  matButton
  type="button"
  class="add-to-list-button"
  [matMenuTriggerFor]="menu"
>
  Add to list <i class="fa-solid fa-caret-down button-icon-end"></i>
</button>
<mat-menu #menu="matMenu" xPosition="before" class="app-menu add-to-list-menu">
  @for (item of items; track item) {
    <button mat-menu-item [disabled]="item.disabled" (click)="item.command?.()">
      {{ item.label }}
    </button>
  }
</mat-menu>
